import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LoaderService } from 'src/app/core/loader/loader.service';

@Injectable({
  providedIn: 'root'
})
export class SageSalesService {

  url = "/api/sage";
  
  constructor(private http: HttpClient, private loaderService: LoaderService) { }

  getSalesByOrganization(id): Observable<any> {
    this.loaderService.skipRequest(this.url + "/" + id + "/sales", null);
    return this.http.get<any>(this.url + "/" + id + "/sales");
  }

  getSageSaleLines(organization_id, sale_id): Observable<any> {
    this.loaderService.skipRequest(this.url + "/" + organization_id + "/sales/" + sale_id + "/lines", null);
    return this.http.get<any>(this.url + "/" + organization_id + "/sales/" + sale_id + "/lines");
  }
}
